<!-- MDRevolutionStatus.vue -->
<script setup lang="ts">
import { LayoutOrientation, DateDisplayFormat } from '../../../Enums/UiEnums'
import { EnrolementStatusType } from '../../../Enums/ChoiceEnums';
import { IRadioButtonItem } from '../../../components/Inputs/RadioButtonGroupModels';
import RadioButtonGroup from '../../../components/Inputs/RadioButtonGroup.vue';
import SimpleFlexTable from '../../../components/Table/SimpleFlexTable.vue';
import SimpleFlexTableRow from '../../../components/Table/SimpleFlexTableRow.vue';
import DatePickerNoTZ from '../../../components/DatePickerNoTZ.vue';
import { IPatientDecodeValue } from '../../../lib/Models/Patient/IPatientDecodeValue';

    const props = defineProps<{
        patientData: IPatientDecodeValue
    }>();

    enum ColIndex
    {
        Type,
        Consent
    }

    const enrolementOptions: IRadioButtonItem[] = [
        { text: "Unknown", value: EnrolementStatusType.Unknown },
        { text: "Enrolled", value: EnrolementStatusType.Enrolled },
        { text: "Disenrolled", value: EnrolementStatusType.DisEnrolled },
        { text: "Opted-Out", value: EnrolementStatusType.OptedOut },
    ];

    const emits = defineEmits(["update:patientData"]);
    function emitPatientData()
    {
        emits("update:patientData", props.patientData);
    }
</script>

<template>
    <SimpleFlexTable :columnClasses='["simple-cell TitleCol", "simple-cell"]'>
        <SimpleFlexTableRow rowClass="simple-row">
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    CCM Status
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <RadioButtonGroup 
                        v-model="patientData.mdrCcmStatus" 
                        @update:modelValue="emitPatientData"
                        :items="enrolementOptions" 
                        :layout="LayoutOrientation.Horz" />
                </template>
            </template>
        </SimpleFlexTableRow>

        <SimpleFlexTableRow>
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    CCM Date
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <DatePickerNoTZ 
                        v-model:value="patientData.mdrCcmDate" 
                        :internalDataFormat="DateDisplayFormat.ISO8601"
                        @update:modelValue="emitPatientData"
                        :displayFormat="DateDisplayFormat.NumericDashDate" 
                        :disabled="EnrolementStatusType.Unknown == patientData.mdrCcmStatus" />
                </template>
            </template>
        </SimpleFlexTableRow>        

        <SimpleFlexTableRow rowClass="simple-row">
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    RPM Status
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <RadioButtonGroup 
                        v-model="patientData.mdrRpmStatus" 
                        @update:modelValue="emitPatientData"
                        :items="enrolementOptions" 
                        :layout="LayoutOrientation.Horz" />
                </template>
            </template>
        </SimpleFlexTableRow>        

        <SimpleFlexTableRow>
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    RPM Date
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <DatePickerNoTZ 
                        v-model:value="patientData.mdrRpmDate" 
                        :internalDataFormat="DateDisplayFormat.ISO8601"
                        @update:value="emitPatientData"
                        :displayFormat="DateDisplayFormat.NumericDashDate" 
                        :disabled="EnrolementStatusType.Unknown == patientData.mdrRpmStatus" />
                </template>
            </template>
        </SimpleFlexTableRow>        

    </SimpleFlexTable>
</template>